import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

type RequestBody = {
  componentId: number;
};

export const useInitializeRealTimePricing: MutationFunction<
  unknown,
  RequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ componentId }) =>
      request(`/quotes/components/${componentId}/real_time_pricing_plans`, {
        query,
        init: {
          method: 'POST',
        },
      }),
    ...queryOptions,
    mutationKey: ['direct-pricing'],
  });
};
